import { useContext } from 'react';
import type { Context } from 'react';

import { WizardContext } from '..';
import type { WizardData } from '..';

export const useWizardContext = <V extends object, VS extends object, SE>() =>
  useContext<WizardData<V, VS, SE>>(
    WizardContext as unknown as Context<WizardData<V, VS, SE>>,
  );
